import { cdn_url } from '@shared/cdn';

const imgSrc = cdn_url('/static/css/images/homepage/interactive-step.gif');

function loadImage() {
  const interactiveImage = document.getElementById('interactiveStepImage');
  if (interactiveImage) {
    interactiveImage.setAttribute('src', imgSrc);
  }
}

if (document.readyState === 'complete') {
  loadImage();
} else {
  window.addEventListener('load', loadImage, false);
}
